import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircleIcon from "@mui/icons-material/Circle";

const StatusBadge = ({ color, text }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      backgroundColor: "rgba(250, 235, 188, 0.8)",
      borderRadius: 1,
      px: 1.5,
      py: 0.5,
      color: "white",
      ml: 2,
    }}
  >
    <CircleIcon sx={{ fontSize: 10, color, mr: 1 }} />
    <Typography variant="caption" color="black" fontWeight={500}>
      {text}
    </Typography>
  </Box>
);

export default StatusBadge;
